import { kbbTheme } from '@argo/themes';
export default kbbTheme.colors;
//# sourceMappingURL=index.js.map